import React from "react";
import './LoginPage.css'

interface LoginProps {
    handleLogin: () => void;
}

const LoginPage: React.FC<LoginProps> = ({
    handleLogin
}) => {
    return (
        <div>
            <img className="background" src="/MDCLogo-2023-Metal-Small.png" alt="Background" />
            <div className="login-container">
                <img className="mdc-logo-login" src="/MDCExtended.png" alt="Mathias Die Company Logo" />
                <h1 className="login-header">Login</h1>
                <button className="login-button" onClick={handleLogin}>Login with Entra ID</button>
            </div>
        </div>
    )
}

export default LoginPage;